<div class="kl-image-field" [class.kl-image-field--mb-2]="marginBottom()">
  @if (label()) {
    <kl-label [label]="label()" [htmlFor]="fieldId()" />
  }

  <div class="kl-image-field__main">
    <button
      type="button"
      class="kl-image-field__preview"
      [disabled]="disabled() || !previewUrl()"
      [class.kl-image-field__preview--interactive]="!disabled() && !!previewUrl()"
      (click)="openPreviewDialog(false)">
      @if (previewUrl(); as src) {
        <img [src]="src" alt="" />
      } @else {
        <span class="kl-image-field__empty" aria-hidden="true">
          <i class="ph ph-image" aria-hidden="true"></i>
        </span>
      }
    </button>

    <div class="kl-image-field__actions">
      <p-button
        type="button"
        [label]="'upload_image' | translate"
        icon="ph ph-upload-simple"
        severity="success"
        [outlined]="true"
        size="small"
        class="w-100 kl-image-field__btn"
        [disabled]="disabled()"
        (onClick)="openPreviewDialog(true)" />

      <p-button
        type="button"
        [label]="'delete' | translate"
        icon="ph ph-trash"
        severity="danger"
        [outlined]="true"
        size="small"
        class="w-100 kl-image-field__btn"
        [disabled]="disabled() || !previewUrl()"
        (onClick)="clearImage()" />
    </div>
  </div>
</div>
